import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Observable, forkJoin, of } from 'rxjs';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import * as _moment from 'moment';

import { ItemComponent } from '../../classes/item-component';
import { Product } from '../../classes/product';
import { Category } from '../../classes/category';


import { EditorService } from '../../services/editor/editor.service';
import { AuthService } from '../../services/auth/auth.service';
import { ProductService } from '../../services/product/product.service';
import { ProviderService } from '../../services/provider/provider.service';
import { CategoryService } from '../../services/category/category.service';
import { MessageService } from '../../services/message/message.service';
import { NavigationService } from '../../services/navigation/navigation.service';
import { MediaSetService } from '../../services/media-set/media-set.service';
import { STAGES } from '../../services/utils/stages';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { map } from 'rxjs/operators';
import { ProductEditor } from '../product-item/product-item.component';
import { log } from 'console';
import { GenericDialog } from '../../classes/generic-dialog';
import { GenericDialogComponent } from '../dialog/generic-dialog/generic-dialog.component';

const moment = _moment;

@Component({
  selector: 'app-product-free-item',
  templateUrl: './product-free-item.component.html',
  styleUrls: ['./product-free-item.component.css'],
  providers: [DatePipe]
})
export class ProductFreeItemComponent extends ItemComponent implements OnInit {

  @Input() public product: Product;
  @Input() public panelOpenState = false;
  @Input() public edit = false;
  @Input() public cancelRedirectUrl = '';
  @Input() public tipsOpen = false;
  @Input() public initialValidation = false;

  @Input() public otherHaveDefaults = false;

  public editor: ProductEditor;
  public info: boolean;
  public isRoot = false;
  public isEnterprise = false;
  public editorInitialized = false;
  public assistant = false;
  public isEnded = false;

  constructor(
    public dialog: MatDialog,
    public editorService: EditorService,
    private router: Router,
    public authService: AuthService,
    private productService: ProductService,
    private categoryService: CategoryService,
    private messageService: MessageService,
    private navigationService: NavigationService,
    private mediaSetService: MediaSetService,
    private providerService: ProviderService,
    private profileService: ProfileService
  ) {
      super();
   }

  createEditorSteps(categories: Category[], emailAddresses: Observable<any>): void {

    (<any>this.product).KategorieEnterprise = null;
    (<any>this.product).KategorieSortierung = null;
    (<any>this.product).KategorieSnoopr = null;
    if ((<any>this.product).Kategorien) {
      for (let index = 0; index < (<any>this.product).Kategorien.length; index++) {
        const element = (<any>this.product).Kategorien[index];
        const split = /^(.{1,})-(.*)$/.exec(element.ID);
        if (split.length === 3) {
          const consumerSuffix = split[2];
          if (consumerSuffix !== 'SNOOPR') {
            (<any>this.product).KategorieSortierung = element.Sortierung;
            (<any>this.product).KategorieEnterprise = element.ID;
          } else {
            (<any>this.product).KategorieSnoopr = element.ID;
          }
        }
      }
    }

    // create step 1
    this.editor.steps.push({
      label: 'Werbetexte formulieren',
      fields: [ { // Überschrift
        template: '<p><strong>Gezielt die Zielgruppe ansprechen</strong></p>'
      }, {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [{ // Bezeichnung
          key: 'Bezeichnung',
          type: 'input',
          className: 'flex-1',
          templateOptions: {
            floatLabel: 'always',
            appearance: 'outline',
            placeholder: 'Titel des Produktes',
            description: 'Der Titel sollte unbedingt prägnant sein. \
              Über den Titel wird die Zielgruppe mit ihren Wünschen \
              und Bedürfnissen angesprochen. Er nimmt wesentlichen Einfluss auf das Ranking.',
            required: true,
            disabled: true,
            maxLength: 60,
            focus: () => { this.editorService.enter(this.product.ID, 'Bezeichnung'); },
            blur: () => { this.editorService.leave(); }
          },
          expressionProperties: {
            'templateOptions.label': (model) => 'Titel (' + model.Bezeichnung.length + ' / 60 Zeichen)'
          }
        }, { // Beschreibung
          key: 'AnbieterName',
          type: 'input',
          className: 'flex-1',
          templateOptions: {
            floatLabel: 'always',
            appearance: 'outline',
            placeholder: 'AnbieterName',
            description: 'Statt des Untertitels wir bei Free-Varianten der Anbietername angezeigt',
            required: true,
            disabled: true,
            maxLength: 65,
            focus: () => { this.editorService.enter(this.product.ID, 'AnbieterName'); },
            blur: () => { this.editorService.leave(); }
          },
          expressionProperties: {
            'templateOptions.label': (model) => 'Untertitel (' + model.AnbieterName.length + ' / 65 Zeichen)'
          }
        }]
      }, {
        template: '<br/><p><strong>Highlights</strong></p>',
      }, {
        key: 'Highlights',
        type: 'repeat-drag-drop',
        fieldArray: {
          fieldGroupClassName: 'display-flex',
          templateOptions: {
            label: 'Highlight hinzufügen',
            maxLength: (this.product.AnbieterRolle === 'Versicherer' ? ((this.isEnterprise || this.isRoot) ? 10 : 5) : 5),
            minLength: 1,
            onDrop: (previousIndex, currentIndex) => { }
          },
          fieldGroup: [{ // Text
            className: 'flex-1',
            type: 'input',
            key: 'Text',
            templateOptions: {
              disabled: true,
              floatLabel: 'always',
              required: true,
              maxLength: 80,
              placeholder: 'Besonderheit für die Zielgruppe?',
              appearance: 'outline',
              focus: (f) => {
                const fc = f.formControl.parent;
                const arr = fc.parent.controls;
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i] === fc) {
                    this.editorService.enter(this.product.ID, 'Highlight' + (i + 1));
                    break;
                  }
                }
              },
              blur: () => { this.editorService.leave(); }
            },
            expressionProperties: {
              'templateOptions.label': (model) => 'Highlight (' + (model && model.Text ? model.Text.length : 0) + ' / 80 Zeichen)'
            },
            validators: {
              required: {
                expression: (field) => {
                  if (!field.value) {
                    field.markAsTouched();
                    return false;
                  }
                  return true;
                }
              }
            }
          }]
        },
        validators: {
          minOne: {
            expression: (field) => {
              return (field.controls.length > 0);
            },
            message: () => 'Es muss mindestens ein Highlight eingetragen werden.',
          },
        }
      }, {
        template: '<br/><p><strong>Suchbegriffe</strong></p>',
      },{ // Stichworte
        key: 'Suchbegriffe',
        type: 'input',
        templateOptions: {
          floatLabel: 'always',
          appearance: 'outline',
          placeholder: 'z. B. drohne hexacopter octocopter',
          description: 'Stichworte, unter denen das Produkt in der Suchmaschine gefunden werden soll. \
            Stichworte sind durch Leerzeichen voneiner zu trennen. Bitte in die Lage des Suchenden \
            versetzen und möglichst wenig Fachbegriffe und Abkürzungen verwenden.'
        },
        expressionProperties: {
          'templateOptions.label': (model) => {
            let count = 0;
            if (typeof model.Suchbegriffe === 'string') {
              const split = model.Suchbegriffe.split(' ');
              for (let i = 0; i < split.length; i++) {
                if (split[i].trim().length > 0) {
                  count++;
                }
              }
            }
            return 'Suchbegriffe / Stichworte (' + count + ' / 10 Begriffe)';
          }
        },
        validators: {
          specialCharacter: {
            expression: (field) => {
              if (field.value !== '') {
                return (/^[A-Za-z0-9äÄöÖüÜß\-\ ]*$/.test(field.value));
              } else {
                return true;
              }
            },
            message: () => 'Sonderzeichen sind unzulässig.'
          },
          maxWords: {
            expression: (field) => {
              let count = 0;
              const split = (field.value || '').split(' ');
              for (let i = 0; i < split.length; i++) {
                if (split[i].trim().length > 0) {
                  count++;
                }
              }
              return count <= 10;
            },
            message: () => 'Maximal 10 Suchbegriffe zulässig.'
          },
          uniqueWords: {
            expression: (field) => {
              const split = (field.value || '').split(' ');
              for (let i = 0; i < split.length; i++) {
                split[i] = split[i].trim().toLowerCase();
              }

              for (let i = 0; i < split.length; i++) {
                if (split[i].length > 0 && split.indexOf(split[i], i + 1) !== -1) {
                  return false;
                }
              }
              return true;
            },
            message: () => 'Suchbegriffe dürfen nicht mehrmals angegeben werden.'
          }
        }
      }]
    });
    // create step 2
    this.editor.steps.push({
      label: 'Ansprechpartner',
      fields: [ { // Überschrift
        template: '<p><strong>Ansprechpartner</strong></p>'
      }, {
        key: 'AnsprechPartnerAnrede',
        type: 'input',
        templateOptions: {
          label: 'Anrede',
          floatLabel: 'always',
          appearance: 'outline',
          required: true,
          disabled: true
        }
      }, {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [{
          key: 'AnsprechPartnerVorname',
          type: 'input',
          className: 'flex-1',
          templateOptions: {
            label: 'Vorname',
            floatLabel: 'always',
            appearance: 'outline',
            required: true,
            disabled: true
          }
        }, {
          key: 'AnsprechPartnerName',
          type: 'input',
          className: 'flex-1',
          templateOptions: {
            label: 'Name',
            floatLabel: 'always',
            appearance: 'outline',
            required: true,
            disabled: true
          }
        }]
      }, {
        key: 'AnsprechPartnerEmail',
        type: 'input',
        templateOptions: {
          label: 'E-Mail Adresse',
          floatLabel: 'always',
          appearance: 'outline',
          required: true,
          disabled: true
        }
      }]
    });

    // create step3
    this.editor.steps.push({
      label: 'Crawlingdetails',
      fields: [{
        key: 'Url',
        type: 'input',
        templateOptions: {
          label: 'Url',
          floatLabel: 'always',
          appearance: 'outline',
          required: true,
          disabled: true
        }
      }, {
        key: 'CrawlingDate',
        type: 'extended-datepicker',
        templateOptions: {
          label: 'Crawling Date',
          floatLabel: 'always',
          placeholder: 'TT.MM.JJJJ',
          appearance: 'outline',
          description: 'Zeitpunkt, an dem die Url vom Crawler besucht wurde.',
          required: true,
          disabled: true,
          datepickerOptions: {
            startAt: moment(),
            startView: 'month',
            touchUi: true
          }
        }
      },
      { // Verkaufsprodukt
        key: 'KategorieSnoopr',
        type: 'category-select',
        className: 'flex-1',
        templateOptions: {
          single: true,
          required: false,
          disabled: true,
          label: 'Verknüpfung zur Kategorie (Verkaufsprodukt)',
          floatLabel: 'always',
          appearance: 'outline',
          description: 'Ein Produkt muss mit einem Verkaufsprodukt verknüpft werden, \
            in dem es gelistet werden soll. Überlicherweise wird ein Produkt \
            nur in einer Kategorie gelistet.',
          categories: new Observable(subscriber => {
            const result = [];

            categories.forEach((category: Category) => {
              if (category.ID === 'ALL' || category.ID === 'NONE') {
                return;
              }

              if (category.ID.indexOf('-SNOOPR') < 0) {
                return;
              }
              result.push({
                value: category.ID,
                group: category.ProduktgruppenID,
                label: category.Bezeichnung,
                disabled: false,
                selected: (<any>this.product).KategorieSnoopr === category.ID
              });
            });

            subscriber.next(result);
            subscriber.complete();
          })
        }
      }]
    });


    this.editor.steps.push({
      label: 'Produkt veröffentlichen',
      fields: [{ // Leerzeile / Zwischenüberschrift
        template: '<p><strong>Zeitraum festlegen</strong></p>'
      }, { // 1. Zeile
        // key: 'Veroeffentlichung',
        fieldGroupClassName: 'display-flex',
        fieldGroup: [{ // Beginn / Von
          key: 'Beginn',
          type: 'extended-datepicker',
          className: 'flex-1',
          templateOptions: {
            label: 'Von',
            floatLabel: 'always',
            placeholder: 'TT.MM.JJJJ',
            appearance: 'outline',
            description: 'Tag, ab dem das Produkt öffentlich verfügbar sein soll. \
              Die Ressource ist ab 0 Uhr des Tages verfügbar, aber i. d. R. nicht \
              sofort in der Anwendung sichtbar. Maximale Vorausdatierung: 3 Monate.',
            required: true,
            disabled: true,
            datepickerOptions: {
              min: moment(this.product.Beginn).isBefore(moment()) ? moment(this.product.Beginn) : moment(),
              max: moment().add(3, 'months'),
              startAt: moment(),
              startView: 'month',
              touchUi: true
            }
          }
        }, { // Ablauf / Bis
          key: 'Ablauf',
          type: 'extended-datepicker',
          className: 'flex-1',
          templateOptions: {
            label: 'Bis',
            floatLabel: 'always',
            placeholder: 'TT.MM.JJJJ',
            appearance: 'outline',
            description: 'Tag, ab dem das Produkt öffentlich nicht mehr verfügbar sein soll. \
              Die Ressource ist ab 0 Uhr des Tages nicht mehr veröffentlicht. Eine \
              unbegrenzte Dauer ist über ein spätes Ablaufdatum einzustellen.',
            required: true,
            disabled: true,
            datepickerOptions: {
              initDate: moment('2099-12-31'),
              min: moment().add(1, 'days'),
              max: moment('2099-12-31'),
              startAt: moment().add(1, 'years'),
              startView: 'year',
              touchUi: true,
              required: true
            }
          },
          defaultValue: moment('2099-01-01').toDate()
        }]
      }, { // Leerzeile / Zwischenüberschrift
        template: '<p><strong>Status verwalten</strong></p>',
        hideExpression: () => !this.isRoot && !this.isEnterprise, // only for b-tix and enterprise
      }, {
        // key: 'Stages',
        fieldGroupClassName: 'display-flex',
        fieldGroup: [{ // Stages
          key: 'Stages',
          type: 'select',
          className: 'flex-1',
          templateOptions: {
            multiple: true,
            required: true,
            label: 'Systemumgebung',
            floatLabel: 'always',
            appearance: 'outline',
            description: 'Auswahl der Betriebsumgebung/en, auf der bzw. denen \
              das Produkt verfügbar sein soll. Je nach Benutzerkonto ist die \
              Auswahl eingeschränkt.',
            options: STAGES.map(stage => ({
              value: stage.value,
              label: stage.name,
              disabled: false
            }))
          },
          hideExpression: () => !this.isRoot && !this.isEnterprise, // only for b-tix and enterprise
          defaultValue: ['Test']
        }]
      }, { // Leerzeile
        template: '<br/>'
      }, {
        fieldGroupClassName: 'display-flex',
        fieldGroup: [{ // Sichtberechtigungen
          key: 'Berechtigungen',
          type: 'select',
          className: 'flex-1',
          templateOptions: {
            multiple: true,
            required: true,
            disabled: true,
            label: 'Sichtberechtigung',
            floatLabel: 'always',
            appearance: 'outline',
            description: 'Im Normalfall sollte ein Produkt sowohl für Vermittler als \
              auch für Verbraucher sichtbar sein. In seltenen Ausnahmen kann es sinnvoll sein, \
              Inhalte nur für Vermittler oder für Verbraucher zu veröffentlichen. ',
            options: [
              { value: 'ROLE_BROKER', label: 'Makler' },
              { value: 'ROLE_CUSTOMER', label: 'Verbraucher' },
            ]
          },
          defaultValue: ['ROLE_BROKER', 'ROLE_CUSTOMER'],
          hideExpression: () => !this.isRoot,
        },
        {
            template: '<p>Im Normalfall ist ein Produkt sowohl für Vermittler als \
              auch für Verbraucher sichtbar. In seltenen Ausnahmen kann es sinnvoll sein, \
              Inhalte nur für Vermittler oder für Verbraucher zu veröffentlichen. Bitte \
              formulieren Sie diese Anforderung im Bereich "Technische Freigabe".</p>',
            hideExpression: () => !this.isEnterprise,
        }]
      }, { // Leerzeile
        template: '<br/>&nbsp;<br/>'
      }, { // Status
        key: 'Status',
        type: 'select',
        templateOptions: {
          multiple: false,
          required: false,
          disabled: true,
          label: 'Status der Veröffentlichung',
          floatLabel: 'always',
          appearance: 'outline',
          description: 'Diese Anzeige ist maßgeblich für die Veröffentlichung \
            Ihres Produktes. Achtung: Es kann mehrere Stunden dauern, bis Ihr \
            Produkt tatsächlich in der Suchmaschine angezeigt wird.',
          options: [
            { value: 'ENTWURF', label: 'Entwurf (unveröffentlicht)', disabled: true },
            { value: 'IN_PRUEFUNG', label: 'In Prüfung (zu veröffentlichen)', disabled: true },
            { value: 'FREIGEGEBEN', label: 'Live (veröffentlicht)', disabled: true }
          ]
        },
        defaultValue: ['ENTWURF']
      }]
    });
  }

  getModelName(): string {
    return this.product.Modell.replace('_', ' ');
  }

  initEditor() {
    if (!this.editorInitialized) {
      this.navigationService.startLoading('product_editor_init');

      this.editor = new ProductEditor(
        this,
        this.router,
        this.dialog,
        this.productService,
        this.messageService,
        this.editorService
      );

      forkJoin([
        this.product.ID ? this.productService.loadProduct(this.product.ID) : of(this.product),
        this.product.MediaSet ? this.mediaSetService.loadMediaSet(this.product.MediaSet) : of(null),
      ]).subscribe((result) => {
        this.product = result[0];
        this.product.MediaSetInstanz = result[1];

        this.editor.title = 'Produkt-ID: ' + this.product.ID + ' (' + this.getModelName() + ')';
        this.editor.setInfo1(() => 'Version ' + this.product.Version.toString()
          + ' vom ' + moment(this.product.Aenderungsdatum).format('DD.MM. [um] HH:mm [Uhr]'));
        this.editor.setInfo2(() => 'Erstelldatum '
          + moment(this.product.Erstelldatum).format('DD.MM.YYYY'));

        let emailAddresses = of([]);
        if (this.product.AnbieterRolle === 'Makler') {
          emailAddresses = this.profileService.loadProfile(this.product.AnbieterID).pipe(
            map(profile => profile.Emails.filter(email => email.Verifiziert).map(email => {
              return {
                value: email.Email,
                label: email.Email
              };
            }))
          );
        }

        if (this.authService.isDefault()) {
          this.createEditorSteps(this.categoryService.categoryList, emailAddresses);
          this.editorInitialized = true;

          this.navigationService.stopLoading('product_editor_init');
        } else {
          this.categoryService.loadCategoryList(true, true).subscribe((categories) => {
            this.createEditorSteps(categories, emailAddresses);
            this.editorInitialized = true;

            this.navigationService.stopLoading('product_editor_init');
          });
        }
      });
    }
  }

  editProduct(edit): void {
    this.info = false;
    this.edit = edit;
    this.assistant = edit;

    if (edit) {
      this.initEditor();
    } else if (this.cancelRedirectUrl) {
      this.router.navigate([this.cancelRedirectUrl]);
    } else if (this.editorInitialized) {
      this.editorInitialized = false;
    }
  }

  showSearchBotInfo(): void {
    const genericDialog = new GenericDialog();
    const dateStr = this.getDateString(this.product.CrawlingDate);
    const strBeschreibung = 'Gefunden auf ' + this.getUrl(this.product.Url);
    const strText = 'Dieses Produkt wurde vom <b>Snoopr Search Bot</b> auf der Webseite des Anbieters gefunden'
      + ' und am ' + dateStr + ' automatisch indexiert'
      + ' Aus diesem Grund stehen nur eingeschränkte Informationen und digitale Prozesse zur Verfügung.'
      + ' <a href="https://classic.snoopr.de/search-bot" target="_blank">Mehr Infos zum Snoopr Search Bot</a>'
      + '<br/><br/>' + strBeschreibung;
    genericDialog.titel = 'Kein Beispielpreis verfügbar';
    genericDialog.text = strText;
    const dialogRef = this.dialog.open(GenericDialogComponent, {
      maxWidth: '750px',
      maxHeight: '92%',
      data: genericDialog
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  getDateString(crawlingDate): String {
    const date = new Date(crawlingDate);
    const dd = date.getDate();
    let ddStr = String(dd);
    const mm = date.getMonth();
    let mmStr = '';

    if (dd < 10)  {
      ddStr = '0' + dd;
    }

      switch (mm) {
        case 0:
          mmStr = 'Januar';
          break;
        case 1:
          mmStr = 'Februar';
          break;
        case 2:
          mmStr = 'März';
          break;
        case 3:
          mmStr = 'April';
          break;
        case 4:
          mmStr = 'Mai';
          break;
        case 5:
          mmStr = 'Juni';
          break;
        case 6:
          mmStr = 'Juli';
          break;
        case 7:
          mmStr = 'August';
          break;
        case 8:
          mmStr = 'September';
          break;
        case 9:
          mmStr = 'Oktober';
          break;
        case 10:
          mmStr = 'November';
          break;
        case 11:
          mmStr = 'Dezember';
          break;
        default:
          mmStr =  'Januar';
          break;
    }
    return  ddStr + '. ' + mmStr;
  }

  getUrl(url): String {

    if (url.indexOf('://') > 0) {
      url = url.split('://')[1];
    }
    const endings = ['aaa', 'aarp', 'abarth', 'abb', 'abbott', 'abbvie', 'abc', 'able', 'abogado', 'abudhabi', 'ac', 'academy', 'accenture', 'accountant', 'accountants', 'aco', 'active', 'actor', 'ad', 'adac', 'ads', 'adult', 'ae', 'aeg', 'aero', 'aetna', 'af', 'afamilycompany', 'afl', 'africa', 'ag', 'agakhan', 'agency', 'ai', 'aig', 'aigo', 'airbus', 'airforce', 'airtel', 'akdn', 'al', 'alfaromeo', 'alibaba', 'alipay', 'allfinanz', 'allstate', 'ally', 'alsace', 'alstom', 'am', 'amazon', 'americanexpress', 'americanfamily', 'amex', 'amfam', 'amica', 'amsterdam', 'an', 'analytics', 'android', 'anquan', 'anz', 'ao', 'aol', 'apartments', 'app', 'apple', 'aq', 'aquarelle', 'ar', 'arab', 'aramco', 'archi', 'army', 'arpa', 'art', 'arte', 'as', 'asda', 'asia', 'associates', 'at', 'athleta', 'attorney', 'au', 'auction', 'audi', 'audible', 'audio', 'auspost', 'author', 'auto', 'autos', 'avianca', 'aw', 'aws', 'ax', 'axa', 'az', 'azure', 'ba', 'baby', 'baidu', 'banamex', 'bananarepublic', 'band', 'bank', 'bar', 'barcelona', 'barclaycard', 'barclays', 'barefoot', 'bargains', 'baseball', 'basketball', 'bauhaus', 'bayern', 'bb', 'bbc', 'bbt', 'bbva', 'bcg', 'bcn', 'bd', 'be', 'beats', 'beauty', 'beer', 'bentley', 'berlin', 'best', 'bestbuy', 'bet', 'bf', 'bg', 'bh', 'bharti', 'bi', 'bible', 'bid', 'bike', 'bing', 'bingo', 'bio', 'biz', 'bj', 'bl', 'black', 'blackfriday', 'blanco', 'blockbuster', 'blog', 'bloomberg', 'blue', 'bm', 'bms', 'bmw', 'bn', 'bnl', 'bnpparibas', 'bo', 'boats', 'boehringer', 'bofa', 'bom', 'bond', 'boo', 'book', 'booking', 'boots', 'bosch', 'bostik', 'boston', 'bot', 'boutique', 'box', 'bq', 'br', 'bradesco', 'bridgestone', 'broadway', 'broker', 'brother', 'brussels', 'bs', 'bt', 'budapest', 'bugatti', 'build', 'builders', 'business', 'buy', 'buzz', 'bv', 'bw', 'by', 'bz', 'bzh', 'ca', 'cab', 'cafe', 'cal', 'call', 'calvinklein', 'cam', 'camera', 'camp', 'cancerresearch', 'canon', 'capetown', 'capital', 'capitalone', 'car', 'caravan', 'cards', 'care', 'career', 'careers', 'cars', 'cartier', 'casa', 'case', 'caseih', 'cash', 'casino', 'cat', 'catering', 'catholic', 'cba', 'cbn', 'cbre', 'cbs', 'cc', 'cd', 'ceb', 'center', 'ceo', 'cern', 'cf', 'cfa', 'cfd', 'cg', 'ch', 'chanel', 'channel', 'charity', 'chase', 'chat', 'cheap', 'chintai', 'chloe', 'christmas', 'chrome', 'chrysler', 'church', 'ci', 'cipriani', 'circle', 'cisco', 'citadel', 'citi', 'citic', 'city', 'cityeats', 'ck', 'cl', 'claims', 'cleaning', 'click', 'clinic', 'clinique', 'clothing', 'cloud', 'club', 'clubmed', 'cm', 'cn', 'co', 'coach', 'codes', 'coffee', 'college', 'cologne', 'com', 'comcast', 'commbank', 'community', 'company', 'compare', 'computer', 'comsec', 'condos', 'construction', 'consulting', 'contact', 'contractors', 'cooking', 'cookingchannel', 'cool', 'coop', 'corsica', 'country', 'coupon', 'coupons', 'courses', 'cpa', 'cr', 'credit', 'creditcard', 'creditunion', 'cricket', 'crown', 'crs', 'cruise', 'cruises', 'csc', 'cu', 'cuisinella', 'cv', 'cw', 'cx', 'cy', 'cymru', 'cyou', 'cz', 'dabur', 'dad', 'dance', 'data', 'date', 'dating', 'datsun', 'day', 'dclk', 'dds', 'de', 'deal', 'dealer', 'deals', 'degree', 'delivery', 'dell', 'deloitte', 'delta', 'democrat', 'dental', 'dentist', 'desi', 'design', 'dev', 'dhl', 'diamonds', 'diet', 'digital', 'direct', 'directory', 'discount', 'discover', 'dish', 'diy', 'dj', 'dk', 'dm', 'dnp', 'do', 'docs', 'doctor', 'dodge', 'dog', 'doha', 'domains', 'doosan', 'dot', 'download', 'drive', 'dtv', 'dubai', 'duck', 'dunlop', 'duns', 'dupont', 'durban', 'dvag', 'dvr', 'dz', 'earth', 'eat', 'ec', 'eco', 'edeka', 'edu', 'education', 'ee', 'eg', 'eh', 'email', 'emerck', 'energy', 'engineer', 'engineering', 'enterprises', 'epost', 'epson', 'equipment', 'er', 'ericsson', 'erni', 'es', 'esq', 'estate', 'esurance', 'et', 'etisalat', 'eu', 'eurovision', 'eus', 'events', 'everbank', 'exchange', 'expert', 'exposed', 'express', 'extraspace', 'fage', 'fail', 'fairwinds', 'faith', 'family', 'fan', 'fans', 'farm', 'farmers', 'fashion', 'fast', 'fedex', 'feedback', 'ferrari', 'ferrero', 'fi', 'fiat', 'fidelity', 'fido', 'film', 'final', 'finance', 'financial', 'fire', 'firestone', 'firmdale', 'fish', 'fishing', 'fit', 'fitness', 'fj', 'fk', 'flickr', 'flights', 'flir', 'florist', 'flowers', 'flsmidth', 'fly', 'fm', 'fo', 'foo', 'food', 'foodnetwork', 'football', 'ford', 'forex', 'forsale', 'forum', 'foundation', 'fox', 'fr', 'free', 'fresenius', 'frl', 'frogans', 'frontdoor', 'frontier', 'ftr', 'fujitsu', 'fujixerox', 'fun', 'fund', 'furniture', 'futbol', 'fyi', 'ga', 'gal', 'gallery', 'gallo', 'gallup', 'game', 'games', 'gap', 'garden', 'gay', 'gb', 'gbiz', 'gd', 'gdn', 'ge', 'gea', 'gent', 'genting', 'george', 'gf', 'gg', 'ggee', 'gh', 'gi', 'gift', 'gifts', 'gives', 'giving', 'gl', 'glade', 'glass', 'gle', 'global', 'globo', 'gm', 'gmail', 'gmbh', 'gmo', 'gmx', 'gn', 'godaddy', 'gold', 'goldpoint', 'golf', 'goo', 'goodhands', 'goodyear', 'goog', 'google', 'gop', 'got', 'gov', 'gp', 'gq', 'gr', 'grainger', 'graphics', 'gratis', 'green', 'gripe', 'grocery', 'group', 'gs', 'gt', 'gu', 'guardian', 'gucci', 'guge', 'guide', 'guitars', 'guru', 'gw', 'gy', 'hair', 'hamburg', 'hangout', 'haus', 'hbo', 'hdfc', 'hdfcbank', 'health', 'healthcare', 'help', 'helsinki', 'here', 'hermes', 'hgtv', 'hiphop', 'hisamitsu', 'hitachi', 'hiv', 'hk', 'hkt', 'hm', 'hn', 'hockey', 'holdings', 'holiday', 'homedepot', 'homegoods', 'homes', 'homesense', 'honda', 'honeywell', 'horse', 'hospital', 'host', 'hosting', 'hot', 'hoteles', 'hotels', 'hotmail', 'house', 'how', 'hr', 'hsbc', 'ht', 'htc', 'hu', 'hughes', 'hyatt', 'hyundai', 'ibm', 'icbc', 'ice', 'icu', 'id', 'ie', 'ieee', 'ifm', 'iinet', 'ikano', 'il', 'im', 'imamat', 'imdb', 'immo', 'immobilien', 'in', 'inc', 'industries', 'infiniti', 'info', 'ing', 'ink', 'institute', 'insurance', 'insure', 'int', 'intel', 'international', 'intuit', 'investments', 'io', 'ipiranga', 'iq', 'ir', 'irish', 'is', 'iselect', 'ismaili', 'ist', 'istanbul', 'it', 'itau', 'itv', 'iveco', 'iwc', 'jaguar', 'java', 'jcb', 'jcp', 'je', 'jeep', 'jetzt', 'jewelry', 'jio', 'jlc', 'jll', 'jm', 'jmp', 'jnj', 'jo', 'jobs', 'joburg', 'jot', 'joy', 'jp', 'jpmorgan', 'jprs', 'juegos', 'juniper', 'kaufen', 'kddi', 'ke', 'kerryhotels', 'kerrylogistics', 'kerryproperties', 'kfh', 'kg', 'kh', 'ki', 'kia', 'kim', 'kinder', 'kindle', 'kitchen', 'kiwi', 'km', 'kn', 'koeln', 'komatsu', 'kosher', 'kp', 'kpmg', 'kpn', 'kr', 'krd', 'kred', 'kuokgroup', 'kw', 'ky', 'kyoto', 'kz', 'la', 'lacaixa', 'ladbrokes', 'lamborghini', 'lamer', 'lancaster', 'lancia', 'lancome', 'land', 'landrover', 'lanxess', 'lasalle', 'lat', 'latino', 'latrobe', 'law', 'lawyer', 'lb', 'lc', 'lds', 'lease', 'leclerc', 'lefrak', 'legal', 'lego', 'lexus', 'lgbt', 'li', 'liaison', 'lidl', 'life', 'lifeinsurance', 'lifestyle', 'lighting', 'like', 'lilly', 'limited', 'limo', 'lincoln', 'linde', 'link', 'lipsy', 'live', 'living', 'lixil', 'lk', 'llc', 'llp', 'loan', 'loans', 'locker', 'locus', 'loft', 'lol', 'london', 'lotte', 'lotto', 'love', 'lpl', 'lplfinancial', 'lr', 'ls', 'lt', 'ltd', 'ltda', 'lu', 'lundbeck', 'lupin', 'luxe', 'luxury', 'lv', 'ly', 'ma', 'macys', 'madrid', 'maif', 'maison', 'makeup', 'man', 'management', 'mango', 'map', 'market', 'marketing', 'markets', 'marriott', 'marshalls', 'maserati', 'mattel', 'mba', 'mc', 'mcd', 'mcdonalds', 'mckinsey', 'md', 'me', 'med', 'media', 'meet', 'melbourne', 'meme', 'memorial', 'men', 'menu', 'meo', 'merckmsd', 'metlife', 'mf', 'mg', 'mh', 'miami', 'microsoft', 'mil', 'mini', 'mint', 'mit', 'mitsubishi', 'mk', 'ml', 'mlb', 'mls', 'mm', 'mma', 'mn', 'mo', 'mobi', 'mobile', 'mobily', 'moda', 'moe', 'moi', 'mom', 'monash', 'money', 'monster', 'montblanc', 'mopar', 'mormon', 'mortgage', 'moscow', 'moto', 'motorcycles', 'mov', 'movie', 'movistar', 'mp', 'mq', 'mr', 'ms', 'msd', 'mt', 'mtn', 'mtpc', 'mtr', 'mu', 'museum', 'mutual', 'mutuelle', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'nab', 'nadex', 'nagoya', 'name', 'nationwide', 'natura', 'navy', 'nba', 'nc', 'ne', 'nec', 'net', 'netbank', 'netflix', 'network', 'neustar', 'new', 'newholland', 'news', 'next', 'nextdirect', 'nexus', 'nf', 'nfl', 'ng', 'ngo', 'nhk', 'ni', 'nico', 'nike', 'nikon', 'ninja', 'nissan', 'nissay', 'nl', 'no', 'nokia', 'northwesternmutual', 'norton', 'now', 'nowruz', 'nowtv', 'np', 'nr', 'nra', 'nrw', 'ntt', 'nu', 'nyc', 'nz', 'obi', 'observer', 'off', 'office', 'okinawa', 'olayan', 'olayangroup', 'oldnavy', 'ollo', 'om', 'omega', 'one', 'ong', 'onl', 'online', 'onyourside', 'ooo', 'open', 'oracle', 'orange', 'org', 'organic', 'orientexpress', 'origins', 'osaka', 'otsuka', 'ott', 'ovh', 'pa', 'page', 'pamperedchef', 'panasonic', 'panerai', 'paris', 'pars', 'partners', 'parts', 'party', 'passagens', 'pay', 'pccw', 'pe', 'pet', 'pf', 'pfizer', 'pg', 'ph', 'pharmacy', 'phd', 'philips', 'phone', 'photo', 'photography', 'photos', 'physio', 'piaget', 'pics', 'pictet', 'pictures', 'pid', 'pin', 'ping', 'pink', 'pioneer', 'pizza', 'pk', 'pl', 'place', 'play', 'playstation', 'plumbing', 'plus', 'pm', 'pn', 'pnc', 'pohl', 'poker', 'politie', 'porn', 'post', 'pr', 'pramerica', 'praxi', 'press', 'prime', 'pro', 'prod', 'productions', 'prof', 'progressive', 'promo', 'properties', 'property', 'protection', 'pru', 'prudential', 'ps', 'pt', 'pub', 'pw', 'pwc', 'py', 'qa', 'qpon', 'quebec', 'quest', 'qvc', 'racing', 'radio', 'raid', 're', 'read', 'realestate', 'realtor', 'realty', 'recipes', 'red', 'redstone', 'redumbrella', 'rehab', 'reise', 'reisen', 'reit', 'reliance', 'ren', 'rent', 'rentals', 'repair', 'report', 'republican', 'rest', 'restaurant', 'review', 'reviews', 'rexroth', 'rich', 'richardli', 'ricoh', 'rightathome', 'ril', 'rio', 'rip', 'rmit', 'ro', 'rocher', 'rocks', 'rodeo', 'rogers', 'room', 'rs', 'rsvp', 'ru', 'rugby', 'ruhr', 'run', 'rw', 'rwe', 'ryukyu', 'sa', 'saarland', 'safe', 'safety', 'sakura', 'sale', 'salon', 'samsclub', 'samsung', 'sandvik', 'sandvikcoromant', 'sanofi', 'sap', 'sapo', 'sarl', 'sas', 'save', 'saxo', 'sb', 'sbi', 'sbs', 'sc', 'sca', 'scb', 'schaeffler', 'schmidt', 'scholarships', 'school', 'schule', 'schwarz', 'science', 'scjohnson', 'scor', 'scot', 'sd', 'se', 'search', 'seat', 'secure', 'security', 'seek', 'select', 'sener', 'services', 'ses', 'seven', 'sew', 'sex', 'sexy', 'sfr', 'sg', 'sh', 'shangrila', 'sharp', 'shaw', 'shell', 'shia', 'shiksha', 'shoes', 'shop', 'shopping', 'shouji', 'show', 'showtime', 'shriram', 'si', 'silk', 'sina', 'singles', 'site', 'sj', 'sk', 'ski', 'skin', 'sky', 'skype', 'sl', 'sling', 'sm', 'smart', 'smile', 'sn', 'sncf', 'so', 'soccer', 'social', 'softbank', 'software', 'sohu', 'solar', 'solutions', 'song', 'sony', 'soy', 'space', 'spiegel', 'sport', 'spot', 'spreadbetting', 'sr', 'srl', 'srt', 'ss', 'st', 'stada', 'staples', 'star', 'starhub', 'statebank', 'statefarm', 'statoil', 'stc', 'stcgroup', 'stockholm', 'storage', 'store', 'stream', 'studio', 'study', 'style', 'su', 'sucks', 'supplies', 'supply', 'support', 'surf', 'surgery', 'suzuki', 'sv', 'swatch', 'swiftcover', 'swiss', 'sx', 'sy', 'sydney', 'symantec', 'systems', 'sz', 'tab', 'taipei', 'talk', 'taobao', 'target', 'tatamotors', 'tatar', 'tattoo', 'tax', 'taxi', 'tc', 'tci', 'td', 'tdk', 'team', 'tech', 'technology', 'tel', 'telecity', 'telefonica', 'temasek', 'tennis', 'teva', 'tf', 'tg', 'th', 'thd', 'theater', 'theatre', 'tiaa', 'tickets', 'tienda', 'tiffany', 'tips', 'tires', 'tirol', 'tj', 'tjmaxx', 'tjx', 'tk', 'tkmaxx', 'tl', 'tm', 'tmall', 'tn', 'to', 'today', 'tokyo', 'tools', 'top', 'toray', 'toshiba', 'total', 'tours', 'town', 'toyota', 'toys', 'tp', 'tr', 'trade', 'trading', 'training', 'travel', 'travelchannel', 'travelers', 'travelersinsurance', 'trust', 'trv', 'tt', 'tube', 'tui', 'tunes', 'tushu', 'tv', 'tvs', 'tw', 'tz', 'ua', 'ubank', 'ubs', 'uconnect', 'ug', 'uk', 'um', 'unicom', 'university', 'uno', 'uol', 'ups', 'us', 'uy', 'uz', 'va', 'vacations', 'vana', 'vanguard', 'vc', 've', 'vegas', 'ventures', 'verisign', 'vermögensberater', 'vermögensberatung', 'versicherung', 'vet', 'vg', 'vi', 'viajes', 'video', 'vig', 'viking', 'villas', 'vin', 'vip', 'virgin', 'visa', 'vision', 'vista', 'vistaprint', 'viva', 'vivo', 'vlaanderen', 'vn', 'vodka', 'volkswagen', 'volvo', 'vote', 'voting', 'voto', 'voyage', 'vu', 'vuelos', 'wales', 'walmart', 'walter', 'wang', 'wanggou', 'warman', 'watch', 'watches', 'weather', 'weatherchannel', 'webcam', 'weber', 'website', 'wed', 'wedding', 'weibo', 'weir', 'wf', 'whoswho', 'wien', 'wiki', 'williamhill', 'win', 'windows', 'wine', 'winners', 'wme', 'wolterskluwer', 'woodside', 'work', 'works', 'world', 'wow', 'ws', 'wtc', 'wtf', 'xbox', 'xerox', 'xfinity', 'xihuan', 'xin', 'xperia', 'xxx', 'xyz', 'yachts', 'yahoo', 'yamaxun', 'yandex', 'ye', 'yodobashi', 'yoga', 'yokohama', 'you', 'youtube', 'yt', 'yun', 'za', 'zappos', 'zara', 'zero', 'zip', 'zippo', 'zm', 'zone', 'zuerich', 'zw'];
    for (let index = 0; index < endings.length; index++) {
      if (url.indexOf('.' + endings[index] + '/') > 0) {
        return url.split('.' + endings[index] + '/')[0] + '.' + endings[index];
      }
    }
    return url;
  }

  isAllowedToPublish() {
    if (!this.authService.isBroker()) {
      return true;
    }
    return this.authService.isBrokerProvider() && this.authService.isBrokerVerified() && this.authService.isBrokerEligibleToPublish();
  }

  ngOnInit() {
    if (this.edit) {
      this.panelOpenState = true;
      this.initEditor();
    }
    this.isEnterprise = this.authService.isEnterprise();
    this.isRoot = this.authService.isSystem();

    this.isEnded = (moment() >= moment(this.product.Ablauf));

  }

  getSearchTerms() {
    if (!this.product.Suchbegriffe) {
      return [];
    }
    let result;
    if (this.product.Suchbegriffe instanceof Array) {
      result = this.product.Suchbegriffe.slice(0, this.product.Suchbegriffe.length);
    } else {
      result = (<any>this.product.Suchbegriffe).split(' ');
    }

    for (let i = result.length - 1; i >= 0; i--) {
      result[i] = result[i].trim().toLowerCase();
      if (result[i].length === 0) {
        result.splice(i, 1);
      }
    }
    return result;
  }
}
